import { Cover } from './Cover'
import { withCover } from './withCover'

const ConnectedCover = withCover(Cover)

export { ConnectedCover as Cover }
